import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18NextModule } from 'angular-i18next';
// import { TooltipModule } from 'ng2-tooltip-directive';
import { SharedModule } from '../shared/shared.module';
import { DashboardModule } from 'src/app/dashboards/dashboard.module';
import { CategoriesListComponent } from './categories-list/categories-list.component';
import { EnquiryPageComponent } from './enquiry-page/enquiry-page.component';
import { CategoryDetailsComponent } from './category-details/category-details.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTreeModule} from '@angular/material/tree';
import { MatIconModule} from '@angular/material/icon';
import { AddNodeDialogComponent } from './enquiry-registration-dialogs/add-node-dialog/add-node-dialog.component';
import { DeleteCategoryDialogComponent } from './enquiry-registration-dialogs/delete-category-dialog/delete-category-dialog.component';
import { DeleteSubCategoryDialogComponent } from './enquiry-registration-dialogs/delete-sub-category-dialog/delete-sub-category-dialog.component';
import { EditNodeDialogComponent } from './enquiry-registration-dialogs/edit-node-dialog/edit-node-dialog.component';
import { UnsavedChangesDialogComponent } from './enquiry-registration-dialogs/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { WarningDialogComponent } from './enquiry-registration-dialogs/warning-dialog/warning-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    CategoriesListComponent,
    EnquiryPageComponent,
    CategoryDetailsComponent,
    AddNodeDialogComponent,
    EditNodeDialogComponent,
    DeleteCategoryDialogComponent,
    DeleteSubCategoryDialogComponent,
    UnsavedChangesDialogComponent,
    WarningDialogComponent
  ],
  imports: [
    DashboardModule,
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatTabsModule,
    MatMenuModule,
    RouterModule,
    FormsModule,
    NgSelectModule,
    // TooltipModule,
    DragDropModule,
    MatTreeModule,
    MatIconModule,
    I18NextModule.forRoot()
  ],
  exports: [    
  ]
})
export class EnquiryRegistrationModule { }
